import PointAndClick from './PointAndClick.js';

import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import { Colors } from '../../consts/Colors.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import FONTS from '../../consts/Fonts.js';


export default class Chapitre5_3 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre5_3"
        })
    }

    init(data){
        this.audioName = 'HourlyInterlapse';
        super.init(data);   
    }

    create(){
        super.create();
        this.animIn(() => {this.displayButtons();} );        

    }

    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "fin"){
            
            // Ajout des elements
            this.openSortie(data.url)
        }
    }

    openSortie(){
        this.ordiPopup = new PopUpBlue(this, 1650, 480, 500, 510)

        let text = "Un vigile a disparu… C’est le\nmoment d’aller voir en\ncoulisses si je ne retrouve pas\nla trace de Leïla Cercis.\nJ’en ai la certitude : elle est ici."
        let textElmt = this.add.text(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5, 0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonNext = new ButtonRounded(this, 0, 0, {
            text: "Fouiller les coulisses",
            color: Colors.Elmt.DarkBlue,
            hoverColor: Colors.Elmt.White,
            textColor: Colors.Text.White,
            textHoverColor: Colors.Text.DarkBlue,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addElementToBody(buttonNext, 35 + buttonNext.height/2)

        let buttonRester = new ButtonRounded(this, 0, 0, {
            text: "Rester ici",
            color: Colors.Elmt.DarkBlue,
            hoverColor: Colors.Elmt.White,
            textColor: Colors.Text.White,
            textHoverColor: Colors.Text.DarkBlue,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addElementToBody(buttonRester, 25 )

        this.ordiPopup.animIn()

        buttonNext.setClickFunction( () => {
            this.animOut()
        })

        buttonRester.setClickFunction( () => {
            this.closePopup();
        })

    }

    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre6")
            }
        })
    }

    animIn(endFunction){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                if(endFunction){
                    endFunction();
                }
            }
        })
    }

}